import { Link } from "react-router-dom";
import { useEffect, useState } from "react";

import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import BASE_URL from "api/Api";
import "assets/theme/admin_list.css";
import { FaCity, FaPlus, FaEdit, FaTrash, FaCheck, FaTimes } from "react-icons/fa";

const CityList = () => {
  const [cities, setCities] = useState([]);
  const [editId, setEditId] = useState(null);
  const [editName, setEditName] = useState("");

  // Fetch cities
  useEffect(() => {
    fetch(`${BASE_URL}super_admin/list_cities`, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("token")}`,
      },
    })
      .then((res) => res.json())
      .then((data) => setCities(data.cities || data))
      .catch((err) => console.error(err));
  }, []);

  // Start edit
  const handleEdit = (city) => {
    setEditId(city.city_id);
    setEditName(city.city_name);
  };

  // Cancel edit
  const handleCancel = () => {
    setEditId(null);
    setEditName("");
  };

  // Save edit
  const handleSave = async (id) => {
    try {
      const res = await fetch(
        `${BASE_URL}super_admin/edit_cities/${id}`,
        {
          method: "PUT",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
          body: JSON.stringify({ city_name: editName }),
        }
      );

      const data = await res.json();
      if (!res.ok) throw new Error(data.message);

      setCities((prev) =>
        prev.map((c) =>
          c.city_id === id ? { ...c, city_name: editName } : c
        )
      );

      handleCancel();
    } catch (error) {
      alert(error.message);
    }
  };

  // Delete city
  const handleDelete = async (id) => {
    if (!window.confirm("Are you sure you want to delete this city?")) return;

    try {
      const res = await fetch(
        `${BASE_URL}super_admin/delete_cities/${id}`,
        {
          method: "DELETE",
          headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
        }
      );

      if (!res.ok) throw new Error("Failed to delete city");

      setCities((prev) => prev.filter((c) => c.city_id !== id));
    } catch (error) {
      alert(error.message);
    }
  };

  return (
    <DashboardLayout>
      <DashboardNavbar />

      <div className="admin-page-container">
        {/* Header */}
        <div className="admin-header-card d-flex align-items-center justify-content-between flex-wrap gap-3">
          <div className="d-flex align-items-center">
            <div className="admin-header-icon">
              <FaCity />
            </div>
            <div>
              <h4 className="admin-header-title">शहर व्यवस्थापन (City Management)</h4>
              <p className="admin-header-subtitle mb-0">
                जिल्हा व उपविभागानुसार शहरांची यादी व माहिती व्यवस्थापित करा
              </p>
            </div>
          </div>

          <Link to="/cities" className="btn-admin-add">
            <FaPlus /> नवीन शहर जोडा
          </Link>
        </div>

        {/* Table Card */}
        <div className="admin-table-card">
          {cities.length === 0 ? (
            <div className="text-center py-5 text-muted">
              कोणतेही शहर आढळले नाही.
            </div>
          ) : (
            <div className="table-responsive">
              <table className="table table-admin-custom">
                <thead>
                  <tr>
                    <th>Sr. No.</th>
                    <th>जिल्हा (District)</th>
                    <th>उपविभाग (Subdistrict)</th>
                    <th>शहर नाव (City Name)</th>
                    <th className="text-end">कृती (Actions)</th>
                  </tr>
                </thead>

                <tbody>
                  {cities.map((city, index) => (
                    <tr key={city.city_id}>
                      <td className="fw-bold text-secondary">{index + 1}</td>

                      <td className="fw-bold text-dark">{city.district_name}</td>

                      <td>
                        <span className="badge bg-light text-dark border">
                          {city.subdistrict_name}
                        </span>
                      </td>

                      <td>
                        {editId === city.city_id ? (
                          <input
                            type="text"
                            className="form-control form-control-sm admin-select py-1 px-2"
                            value={editName}
                            onChange={(e) => setEditName(e.target.value)}
                          />
                        ) : (
                          <span className="fw-semibold text-dark">{city.city_name}</span>
                        )}
                      </td>

                      <td className="text-end">
                        {editId === city.city_id ? (
                          <div className="admin-action-group justify-content-end">
                            <button
                              className="btn-action-icon btn-action-view"
                              onClick={() => handleSave(city.city_id)}
                              title="जतन करा"
                            >
                              <FaCheck />
                            </button>

                            <button
                              className="btn-action-icon btn-action-delete"
                              onClick={handleCancel}
                              title="रद्द करा"
                            >
                              <FaTimes />
                            </button>
                          </div>
                        ) : (
                          <div className="admin-action-group justify-content-end">
                            <button
                              className="btn-action-icon btn-action-edit"
                              onClick={() => handleEdit(city)}
                              title="संपादित करा"
                            >
                              <FaEdit />
                            </button>

                            <button
                              className="btn-action-icon btn-action-delete"
                              onClick={() => handleDelete(city.city_id)}
                              title="हटवा"
                            >
                              <FaTrash />
                            </button>
                          </div>
                        )}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          )}
        </div>
      </div>
    </DashboardLayout>
  );
};

export default CityList;
